import React from 'react';
import { useToast } from '../context/ToastContext';
import styles from './ToastContainer.module.css';
import { CheckCircle, Info, AlertTriangle, XCircle, Trophy, Star, Zap } from 'lucide-react';

const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  const getIcon = (type: string) => {
    switch (type) {
      case 'success':
        return <CheckCircle size={20} />;
      case 'info':
        return <Info size={20} />;
      case 'warning':
        return <AlertTriangle size={20} />;
      case 'error':
        return <XCircle size={20} />;
      case 'celebration':
        return <Trophy size={24} />;
      default:
        return <Info size={20} />;
    }
  };

  return (
    <div className={styles.toastContainer}>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`${styles.toast} ${styles[toast.type]} ${toast.levelUp ? styles.levelUp : ''}`}
        >
          <div className={styles.toastIcon}>
            {getIcon(toast.type)}
          </div>

          <div className={styles.toastContent}>
            {toast.levelUp && (
              <div className={styles.levelUpBadge}>
                <Star className={styles.starIcon} size={16} />
                LEVEL UP!
                <Star className={styles.starIcon} size={16} />
              </div>
            )}

            <div className={styles.toastMessage}>{toast.message}</div>

            {toast.points !== undefined && (
              <div className={styles.pointsBadge}>
                <Zap size={16} className={styles.zapIcon} />
                +{toast.points} ORG POINTS
              </div>
            )}

            {toast.levelUp && toast.newLevel && (
              <div className={styles.newLevelBadge}>
                🎖️ LEVEL {toast.newLevel}{toast.levelTitle ? `: ${toast.levelTitle.toUpperCase()}` : ''}
              </div>
            )}
          </div>

          <button
            className={styles.closeButton}
            onClick={() => removeToast(toast.id)}
            aria-label="Close notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
